import React, { useState } from "react";
import { storyblokEditable } from "@storyblok/react";
import Slider from "react-slick";
import Zoom from 'react-medium-image-zoom';
import Teaser from "./Teaser";
import LifeItem from "./Life-item";
import RichTextFieldNoImages from "./RichTextFieldNoImages";

const extractImagesFromRichText = (richTextContent) => {
    const images = [];
    const extractFromNode = (node) => {
        if (node.type === 'image' && node.attrs && node.attrs.src) {
            images.push({ src: node.attrs.src, alt: node.attrs.alt || '' });
        }
        if (node.content && Array.isArray(node.content)) {
            node.content.forEach(child => extractFromNode(child));
        }
    };

    richTextContent.forEach(node => extractFromNode(node));
    return images;
};

const Life = ({ blok }) => {
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);

    const handleItemClick = (item) => {
        setSelectedItem(item);
        setModalOpen(true);
    };

    const closeModal = () => {
        setModalOpen(false);
        setSelectedItem(null);
    };

    const images = selectedItem ? extractImagesFromRichText(selectedItem.life_event.content) : [];

    const settings = {
        // infinite:  images.length > 3,
        slidesToShow: 3,
        // slidesToScroll: 1,
        swipeToSlide: true,
        fade: true,
        focusOnSelect: true,
        lazyLoad: true,
        dots: true,
        // variableWidth: images.length < 3
    };

    return (
        <section className="life" {...storyblokEditable(blok)}>
            {blok.h2_subtitle && blok.h2_subtitle.map(title => (
                <Teaser key={title._uid} blok={title} />
            ))}
            <div className="life-container">
                {Object.keys(blok).map(key => {
                    if (key.startsWith("life_item_")) {
                        return blok[key].map(item => (
                            <LifeItem key={item._uid} blok={item} onClick={() => handleItemClick(item)} />
                        ));
                    }
                    return null;
                })}
            </div>
            {modalOpen && selectedItem && (
                <div className="modal" onClick={closeModal}>
                    <div className="modal-content-life" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header-life">
                            <h2>{selectedItem.life_text}</h2>
                            <button onClick={closeModal}>
                                <svg width="44" height="44" viewBox="0 0 44 44" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M10.3402 33.6587C10.6152 33.9337 10.9635 34.062 11.3118 34.062C11.6602 34.062 12.0268 33.9337 12.2835 33.6587L22.0002 23.942L31.7168 33.6587C31.9918 33.9337 32.3402 34.062 32.6885 34.062C33.0368 34.062 33.3852 33.9337 33.6602 33.6587C34.1918 33.127 34.1918 32.247 33.6602 31.7154L23.9435 21.9987L33.6602 12.282C34.1918 11.7504 34.1918 10.8704 33.6602 10.3387C33.1285 9.80702 32.2485 9.80702 31.7168 10.3387L22.0002 20.0554L12.2835 10.3387C11.7518 9.80702 10.8718 9.80702 10.3402 10.3387C9.80849 10.8704 9.80849 11.7504 10.3402 12.282L20.0568 21.9987L10.3402 31.7154C9.80849 32.247 9.80849 33.127 10.3402 33.6587Z"
                                        fill="#FFFFFF"/>
                                </svg>
                            </button>
                        </div>
                        <hr/>
                        <div className="modal-body-life">
                            <div className="life-event-text">
                                {selectedItem.life_event && <RichTextFieldNoImages data={selectedItem.life_event} />}
                            </div>
                            <div className="life-item-carousel">
                                <Slider {...settings}>
                                    {images.map((image, index) => (
                                        <Zoom key={index}>
                                            <img src={image.src} alt={image.alt}/>
                                        </Zoom>
                                    ))}
                                </Slider>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </section>
    );
};

export default Life;
